import { Building2, ArrowRight } from 'lucide-react';
import { Button } from '@/components/ui/button';
import { Link } from 'react-router-dom';
import { Alert, AlertDescription, AlertTitle } from '@/components/ui/alert';

export function NoGymSelected() {
    return (
        <Alert className="mb-6 border-amber-500/50 bg-amber-500/10 dark:bg-amber-500/5 transition-all animate-in fade-in slide-in-from-top-4">
            <Building2 className="h-4 w-4 text-amber-500" />
            <AlertTitle className="text-amber-500 font-bold">Contexto de Gimnasio Requerido</AlertTitle>
            <AlertDescription className="text-amber-200/80">
                Para realizar acciones como crear, editar o eliminar registros, primero debes seleccionar un gimnasio.
                <div className="mt-3">
                    <Button asChild size="sm" variant="outline" className="border-amber-500/50 text-amber-500 hover:bg-amber-500/10 hover:text-amber-500">
                        <Link to="/gyms" className="flex items-center gap-2">
                            Ir a Gimnasios <ArrowRight className="h-3 w-3" />
                        </Link>
                    </Button>
                </div>
            </AlertDescription>
        </Alert>
    );
}
